import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import Main from './Main';

const store = createStore(rootReducer,
    compose(
        applyMiddleware(thunk),
        // process.env.NODE_ENV === 'development' && window.devToolsExtension ? window.devToolsExtension() : f => f
        process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    ));

const theme = createMuiTheme({ palette: { primary: { light: '#4791db', main: '#1976d2', dark: '#115293' }, secondary: { main: '#f44336' } }, typography: { useNextVariants: true } });

export default function App(props) {
    console.log('Versão 0.0.3');

    return <Provider store={store}>
        <MuiThemeProvider theme={theme}>
            <Main />
        </MuiThemeProvider>
    </Provider>;
}
